var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5716 1.22266H3.6737C3.08373 1.22266 2.51792 1.45702 2.10075 1.87419C1.68358 2.29136 1.44922 2.85717 1.44922 3.44713V21.243C1.44922 21.8329 1.68358 22.3987 2.10075 22.8159C2.51792 23.2331 3.08373 23.4674 3.6737 23.4674H17.0206C17.6105 23.4674 18.1763 23.2331 18.5935 22.8159C19.0107 22.3987 19.245 21.8329 19.245 21.243V7.89609M12.5716 1.22266L19.245 7.89609M12.5716 1.22266V7.89609H19.245M14.7961 13.4573H5.89817M14.7961 17.9062H5.89817M8.12265 9.00833H5.89817",
    stroke: "#26617D",
    strokeWidth: 2.22448,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.f1af86b52a11f526507cce04e3fd7157.svg";
export { ForwardRef as ReactComponent };